import React, { useState } from "react";
import {
  Button,
  TextField,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { SecondaryButton } from "../../../ui/SecondaryButton";
import { PrimaryButton } from "../../../ui/PrimaryButton";

const ClientCommentModal = ({
  comment: initialComment = "",
  category: initialCategory = "",
  onClose,
  onSubmit,
}) => {
  const [comment, setComment] = useState(initialComment);
  const [category, setCategory] = useState(initialCategory);

  const handleSubmit = () => {
    onSubmit({ comment, category });
  };

  return (
    <>
      <Typography variant="h6" sx={{ pb: 1 }}>
        Коментар клієнта
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
        <Typography>Категорія</Typography>
        <TextField
          fullWidth
          size="small"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        />
      </Box>
      <Box sx={{ display: "flex", gap: 1, flexDirection: "column", mb: 2 }}>
        <Typography>Поточний коментар</Typography>
        <TextField
          multiline
          rows={4}
          fullWidth
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </Box>

      <DialogActions sx={{ p: 0, justifyContent: "start" }}>
        <PrimaryButton onClick={handleSubmit}>Видалити</PrimaryButton>
        <SecondaryButton onClick={onClose}>Закрити</SecondaryButton>
      </DialogActions>
    </>
  );
};

export default ClientCommentModal;
